import type { DiscFormat } from '@physical-movies/core';
import { useI18n } from '../app/context';

const FORMAT_LONG = {
  '4k': 'format.4k',
  hd: 'format.hd',
  combo: 'format.combo',
} as const;

const FORMAT_SHORT = {
  '4k': 'format.4k.short',
  hd: 'format.hd.short',
  combo: 'format.combo.short',
} as const;

const FORMAT_HINT = {
  '4k': 'format.4k.hint',
  hd: 'format.hd.hint',
  combo: 'format.combo.hint',
} as const;

/** "4K UHD" / "4K" / "A single UHD disc", in the active language. */
export function useFormatLabels() {
  const { t } = useI18n();
  return {
    long: (format: DiscFormat) => t(FORMAT_LONG[format]),
    short: (format: DiscFormat) => t(FORMAT_SHORT[format]),
    hint: (format: DiscFormat) => t(FORMAT_HINT[format]),
  };
}
